// Amounts on the billing pages, recomputed client-side exactly as the server
// renders them, so a live update never lands on a different cent or format.

// The server's price format (ApplicationHelper#currency_format_data: unit,
// format, separator, delimiter, precision), sent as a Stimulus data value and
// replayed by the app-wide formatAmount (utils/server-format.util.js) — so a
// live update reads exactly like the server-rendered amount beside it. Kept
// under the billing name for the billing controllers that import it.
export { formatAmount as formatBillingAmount } from "./server-format.util"

// VAT on an integer-cent net, in whole cents — the rounding of
// BillingHelper#checkout_vat_amount (the checkout totals), pinned to agree to
// the cent by test/helpers/billing_helper_test.rb. billing--coupon rounds the
// same way. One rounding of the summed net, because Stripe rounds a tax rate's
// VAT per invoice, not per line (test-mode observation cited on the helper).
export function vatCents(netCents, vatRate) {
  return Math.round((netCents * vatRate) / 100)
}
